<template>
    <div class="header">
        <div>
            <!-- Hearer  -->
            <!-- <div class="mt-4">
                <div class="card">
                    <div class="card-body">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item fw-bolder">Master Data</li>
                                <li class="breadcrumb-item">Transaction Type</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div> -->
            <!-- Card  -->
            <div class="card mt-5">
                <div class="card-header">
                    <!-- Title -->
                    <h4 class="card-header-title">Transaction Type</h4>
                    <!-- Button -->
                    <b-button v-if="isCreat" v-b-modal.modal-1 variant="primary" @click="isAdd = true">
                        <span class="fe fe-user-check mr-2"></span>
                        Create Transaction Type
                    </b-button>
                </div>
                <div class="d-flex justify-content-end mb-3 mt-3 mr-3">
                    <label class="align-self-center mb-0 mr-3">Search</label>
                    <b-form-input v-model="body.search" class="w-auto" placeholder="Type Here..." @change="getList()">
                    </b-form-input>
                </div>
                <vue-good-table :line-numbers="true" :columns="columns" :rows="list.data" :sort-options="{
                    enabled: true,
                    }" :total-rows="list.totalItems" :pagination-options="{
                    enabled: true,
                    perPage: body.perPage,
                    }" style-class="vgt-table border-0 table" @on-page-change="onPageChange"
                    @on-per-page-change="onPageChange" @on-sort-change="onSortChange">
                    <!-- Loading -->
                    <div slot="emptystate" class="text-center font-size-14">
                        No data available
                    </div>
                    <!-- Custom Rows -->
                    <template slot="table-row" slot-scope="props">
                        <!-- Table Action -->
                        <span v-if="props.column.field == 'action'">
                            <b-button v-if="isUpdate" class="no-wrap btn-pill" variant="warning" size="sm"
                                @click="updateData(props.row)">
                                <span class="fe fe-edit"></span>
                            </b-button>
                            <b-button v-if="isDelete" class="no-wrap ml-2" variant="danger" style="margin-left: 5px" size="sm"
                                @click="deleteData(props.row.id)">
                                <span class="fe fe-trash-2"></span>
                            </b-button>
                        </span>
                    </template>
                    <template slot="pagination-bottom" slot-scope="props">
                        <div class="d-flex justify-content-end">
                            <div>
                                <b-pagination :value="1" :total-rows="list.totalItems" :per-page="body.pageSize"
                                    first-number last-number align="right" prev-class="prev-item" next-class="next-item"
                                    class="mr-3 mb-4 mt-0"
                                    @input=" (value) => props.pageChanged({ currentPage: value })">
                                </b-pagination>
                            </div>
                        </div>
                    </template>
                </vue-good-table>
            </div>

            <!-- Modal -->
            <b-modal id="modal-1" hide-footer title="Transaction Type Form">
                <form @submit.prevent="saveAdd()" v-if="isAdd === true">
                    <div class="form-group">
                        <label>TT Code <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="modalCreate.code" @change="isNumber">
                    </div>
                    <div class="form-group">
                        <label>TT Account <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="modalCreate.account">
                    </div>
                    <div class="form-group">
                        <label>TT Type <span class="text-danger">*</span></label>
                        <v-select :options="['Opex', 'Capex']" v-model="modalCreate.type" />
                        <span class="text-sm text-danger"
                            v-show="errors.has('Employee Name')">{{ errors.first("Employee Name") }}</span>
                    </div>
                    <div class="form-group">
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="submit"
                            v-if="isLoading == false">
                            Save
                        </button>
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button"
                            disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </form>

                <form @submit.prevent="saveUpdate()" v-else>
                    <div class="form-group">
                        <label>TT Code <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="modalUpdate.code" @change="isNumber">
                    </div>
                    <div class="form-group">
                        <label>TT Account <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="modalUpdate.account">
                    </div>
                    <div class="form-group">
                        <label>TT Type <span class="text-danger">*</span></label>
                        <v-select :options="['Opex', 'Capex']" v-model="modalUpdate.type" />
                        <span class="text-sm text-danger"
                            v-show="errors.has('Employee Name')">{{ errors.first("Employee Name") }}</span>
                    </div>
                    <div class="form-group">
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="submit"
                            v-if="isLoading == false">
                            Save
                        </button>
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button"
                            disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </form>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import axiosIns from "@/api/axios";
    import axios from "axios";

    export default {
        name: "GentaGendis",
        computed: {
            list() {
                return this.$store.getters["ttAccount/listAccount"];
            },
        },
        data() {
            return {
              body: {
                  pageNumber: 1,
                  pageSize: 10,
                  search: "",
                  field: "",
                  order: ""
              },
              modalCreate: {
                  account: '',
                  code: '',
                  type: ''
              },
              modalUpdate: {
                  account: '',
                  code: '',
                  type: ''
              },
              id: "",
              isAdd: true,
              isLoading: false,
              optionsRole: [{
                      id: 1,
                      name: "Super Admin"
                  },
                  {
                      id: 2,
                      name: "User"
                  },
                  {
                      id: 3,
                      name: "Genta Gendis"
                  },
                  {
                      id: 4,
                      name: "Business Transformation & Governance"
                  },
                  {
                      id: 5,
                      name: "Approval"
                  },
              ],
              columns: [{
                      label: "TT CODE",
                      field: "code",
                      thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
                      tdClass: "no-wrap color-secondary align-middle",
                  },
                  {
                      label: "TT Account",
                      field: "account",
                      thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
                      tdClass: "no-wrap color-secondary align-middle",
                  },
                  {
                      label: "TT Type",
                      field: "type",
                      thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
                      tdClass: "no-wrap color-secondary align-middle",
                  },
                  {
                      label: "Action",
                      field: "action",
                      sortable: false,
                      thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
                      tdClass: "no-wrap color-secondary align-middle",
                  },
              ],
              rows: [{
                      tt_code: '01',
                      tt_account: 'Salaries and benefits',
                      tt_type: 'OPEX'
                  },
                  {
                      tt_code: '02',
                      tt_account: 'Rental of building, vehicle and equipment',
                      tt_type: 'OPEX'
                  },
                  {
                      tt_code: '03',
                      tt_account: 'Insurance',
                      tt_type: 'OPEX'
                  },
                  {
                      tt_code: '60',
                      tt_account: 'Furniture, Fixture & Office Equipment',
                      tt_type: 'CAPEX'
                  },
                  {
                      tt_code: '57',
                      tt_account: 'Transportation & Other Equipment',
                      tt_type: 'CAPEX'
                  },
              ],
              isRead: false,
              isCreat: false,
              isUpdate: false,
              isDelete: false
            };
        },

        mounted() {
          this.checkPermission();
          this.getList();
        },
        methods: {
          async checkPermission() {
            const roleName = localStorage.getItem("roles");
            const roleId = await axiosIns.get("/master-role/find-name?name=" + roleName);
            const menuId = await axiosIns.get("/master-menu/find-link?link=" + this.$route.path);
            const payloadPermission = {
              role_id: roleId.data.data[0]?.id || null,
              menu_id: menuId.data.data[0]?.id || null
            }
            const checkAuth = await axiosIns.post("/master-role/check-permission", payloadPermission);
            if(checkAuth.data.data?.authorization){
              this.isRead = checkAuth.data.data?.authorization.includes('read')
              this.isCreat = checkAuth.data.data?.authorization.includes('create')
              this.isUpdate = checkAuth.data.data?.authorization.includes('update')
              this.isDelete = checkAuth.data.data?.authorization.includes('delete')
            }
          },
            updateData(props) {
                this.$bvModal.show("modal-1");
                this.isAdd = false;
                this.modalUpdate.account = props.account
                this.modalUpdate.code = props.code
                this.modalUpdate.type = props.type
                this.id = props.id;
            },

            getList() {
                this.$store.dispatch("ttAccount/GET_LIST_ACCOUNT", this.body);
            },

            saveAdd() {
                if (this.modalCreate.account && this.modalCreate.code && this.modalCreate.type) {
                    this.isLoading = true;
                    this.$store
                        .dispatch("ttAccount/CREATE_ACCOUNT", this.modalCreate)
                        .then((resp) => {
                            this.$swal("Saved", "Your input has been saved", "success").then(
                                (resp) => {
                                    this.isLoading = false;
                                    (this.modalCreate = {
                                        account: '',
                                        code: '',
                                        type: ''
                                    }),
                                    this.getList();
                                    this.$bvModal.hide("modal-1");
                                }
                            );
                        }).catch((resp) => {
                            this.$swal.mixin({
                                    toast: true,
                                    position: "top-end",
                                    showConfirmButton: false,
                                    timer: 3000,
                                    timerProgressBar: true,
                                    didOpen: (toast) => {
                                        toast.addEventListener("mouseenter", this.$swal.stopTimer);
                                        toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                                    }
                                })
                                .fire({
                                    icon: "error",
                                    title: resp.response.data.error
                                });
                            this.isLoading = false
                        });
                } else {
                    this.$swal.mixin({
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                            }
                        })
                        .fire({
                            icon: "error",
                            title: 'Please fill mandatory data first'
                        });
                }

            },

            saveUpdate() {
                if (this.modalUpdate.account && this.modalUpdate.code && this.modalUpdate.type) {
                    let body = {
                        id: this.id,
                        body: this.modalUpdate
                    };
                    this.isLoading = true;
                    this.$store
                        .dispatch("ttAccount/UPDATE_ACCOUNT", body)
                        .then((resp) => {
                            this.$swal("Saved", "Your input has been saved", "success").then(
                                (resp) => {
                                    this.isLoading = false;
                                    (this.modalUpdate = {
                                        code: '',
                                        type: '',
                                        account: ''
                                    }),
                                    this.getList();
                                    this.$bvModal.hide("modal-1");
                                }
                            );
                        })
                        .catch((err) => {
                          if (axios.isAxiosError(err)) {
                            if (err.response) {
                              this.$swal.mixin({
                                toast: true,
                                position: "top-end",
                                showConfirmButton: false,
                                timer: 3000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                                }
                              })
                                  .fire({
                                    icon: "error",
                                    title: err?.response?.data?.error || null
                                  });
                              this.isLoading = false
                            }
                          } else {
                            this.$swal.mixin({
                              toast: true,
                              position: "top-end",
                              showConfirmButton: false,
                              timer: 3000,
                              timerProgressBar: true,
                              didOpen: (toast) => {
                                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                              }
                            })
                                .fire({
                                  icon: "error",
                                  title: err
                                });
                            this.isLoading = false
                          }
                            /*this.$swal.mixin({
                                    toast: true,
                                    position: "top-end",
                                    showConfirmButton: false,
                                    timer: 3000,
                                    timerProgressBar: true,
                                    didOpen: (toast) => {
                                        toast.addEventListener("mouseenter", this.$swal.stopTimer);
                                        toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                                    }
                                })
                                .fire({
                                    icon: "error",
                                    title: resp.response.data.error
                                });
                            this.isLoading = false*/
                        });
                } else {
                    this.$swal.mixin({
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                            }
                        })
                        .fire({
                            icon: "error",
                            title: 'Please fill mandatory data first'
                        });
                }
            },

            deleteData(id) {
                this.$swal({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#00D97E",
                    cancelButtonColor: "#E63757",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "Cancel",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$store
                            .dispatch("ttAccount/DELETE_ACCOUNT", id)
                            .then((resp) => {
                                this.getList();
                                this.$swal.mixin({
                                        toast: true,
                                        position: "top-end",
                                        showConfirmButton: false,
                                        timer: 3000,
                                        timerProgressBar: true,
                                        didOpen: (toast) => {
                                            toast.addEventListener("mouseenter", this.$swal
                                                .stopTimer);
                                            toast.addEventListener("mouseleave", this.$swal
                                                .resumeTimer);
                                        }
                                    })
                                    .fire({
                                        icon: "success",
                                        title: 'Selected data has been deleted'
                                    });
                            })
                            .catch((resp) => {
                                this.$swal("Error", "Error while delete data", "error");
                            });
                    }
                });
            },

            // filter
            filterPage() {},

            sorting() {
                this.getList();
            },

            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            // Pagination
            onPageChange(payload) {
                this.body.limit = payload.currentPerPage;
                this.body.page = payload.currentPage;
                this.getList();
            },
            onSortChange(params) {
                let sort1 = params[0].field;
                let sort2 = params[0].type;
                this.body.field = sort1
                if (sort2 == 'none') {
                    this.body.order = ''
                } else {
                    this.body.order = sort2
                }
                this.getList();
            },
        },
    };
</script>